import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { PeopleInfoRelated } from "projects/sepidz-web-framework/src/lib/models/peopleInfo-related.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";

@Component({
  selector: "ngx-related-form",
  templateUrl: "./related-form.component.html",
  styleUrls: ["./related-form.component.scss"],
})
export class RelatedFormComponent extends BaseFormComponent<PeopleInfoRelated> {
  @Input() Columns: form_control[];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    if (!this.apiName) this.apiName = "PeopleInfo";
    this.label = this.translate("ClientApp.GNR.PeopleInfo.Related.RelatedPersons");
    this.noLoadData = true;
    super.ngOnInit();
    this.setdefault();
  }
  setdefault() {
    if (!this.model.PeopleInfoId) this.model.PeopleInfoId = 0;
    this.setFormGroup(this.model);
    this.cd.markForCheck();
  }
  async setColumns() {
    Object.assign(this.orignalColumns, this.Columns);
    this.orignalColumns.forEach((c) => {
      if (c.modelName === "RelatedEmail") {
        c.patternKey = "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+";
      }
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }
  public async save() {
    this.result = this.getDataFromFormGroup();
    this.close();
  }
}
